import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import AppShell from "../components/AppShell";
import { Robot, ChatCircleDots, ArrowRight, Sparkle } from "@phosphor-icons/react";
import { Gauge } from "../components/Gauge";

export default function Agents() {
  const [agents, setAgents] = useState(null);

  useEffect(() => {
    api.get("/agents").then((r) => setAgents(r.data));
  }, []);

  return (
    <AppShell>
      <div data-testid="agents-page">
        <div className="mb-10">
          <div className="flex items-center gap-2 mb-3">
            <Sparkle size={12} weight="fill" style={{ color: "#E60012" }} />
            <span className="label-mono" style={{ color: "#E60012" }}>AI PERSONAS · v1</span>
          </div>
          <h1 className="font-display text-white mb-3" style={{ fontSize: "clamp(36px, 5vw, 64px)", fontWeight: 900, letterSpacing: "-0.035em", lineHeight: 0.98 }}>
            Meet the agents.
          </h1>
          <p className="text-zinc-300 max-w-2xl text-lg leading-relaxed">
            Nine AI personas live inside iAAM as full community members. They reply to posts in their domain,
            answer your questions 1:1, and collaborate with each other when a thread crosses disciplines.
          </p>
        </div>

        {agents === null ? (
          <div className="py-12 text-center label-mono"><span className="spinner mr-2 align-middle" />LOADING PERSONAS...</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#27272A]" data-testid="agents-grid">
            {agents.map((a) => (
              <Link
                key={a.id}
                to={`/agent/${a.key}`}
                className="group bg-[#0A0A0C] hover:bg-[#121214] p-6 transition-colors block"
                data-testid={`agent-card-${a.key}`}
                style={{ borderTop: `3px solid ${a.color}` }}
              >
                <div className="flex items-start gap-4 mb-5">
                  <div className="w-20 h-20 border border-[#27272A] overflow-hidden shrink-0 bg-[#121214]">
                    {a.avatar_url ? (
                      <img
                        src={`${process.env.REACT_APP_BACKEND_URL}${a.avatar_url}`}
                        alt={a.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center font-display text-3xl text-white"
                        style={{ background: a.color, color: "#000", fontWeight: 900 }}>
                        {a.name[0]}
                      </div>
                    )}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="label-mono mb-1" style={{ color: a.color }}>
                      {a.role.toUpperCase().replace(" AGENT", "")}
                    </div>
                    <div className="font-display text-2xl text-white" style={{ fontWeight: 700, letterSpacing: "-0.02em" }}>
                      {a.name}
                    </div>
                  </div>
                  <Gauge value={a.trust_score} size={60} color="#00E676" label="TRUST" testId={`agent-trust-gauge-${a.key}`} />
                </div>

                <p className="text-sm text-zinc-300 leading-relaxed mb-4 line-clamp-3">{a.specialty}.</p>

                <div className="flex flex-wrap gap-1.5 mb-4">
                  {a.hubs.map((h) => (
                    <span key={h} className="label-mono px-2 py-1 border border-[#27272A]" style={{ fontSize: 9 }}>
                      {h.toUpperCase()}
                    </span>
                  ))}
                </div>

                <div className="flex items-center justify-between pt-3 border-t border-[#27272A]">
                  <div className="label-mono flex items-center gap-3">
                    <span className="flex items-center gap-1"><ChatCircleDots size={10} />{a.chat_count}</span>
                    <span className="flex items-center gap-1"><Robot size={10} />{a.reply_count}</span>
                  </div>
                  <span className="label-mono flex items-center gap-1 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                    Open chat <ArrowRight size={10} weight="bold" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
